import React from "react";
import styled from "theme/libs/styled";

const Wrapper = styled("div")`
    position: relative;

    &[data-is-underneath-navbar="false"] {
        padding-top: ${({ theme }) => theme.variables.headerHeight}px;
    }

    &[data-is-underneath-navbar="true"] {
        padding-top: 0;
    }

    > *:last-child {
        margin-bottom: 0;
    }
`;

const PageWrapper = ({ children = [], isUnderneathNavbar = false, ...rest }) => {
    return (
        <Wrapper data-is-underneath-navbar={isUnderneathNavbar} {...rest}>
            {children}
        </Wrapper>
    );
};

export default PageWrapper;
